$(document).on(
  "click",
  ".bestseller_product .thumbnail img.thumb_img",
  function () {
    var src = $(this).attr("src");
    var title = $(".other-products .products.active").attr("title");
    $(".featured_media .image_featured img").attr("src", src);
    $(".featured_media .image_featured div").attr("data-title", title);
  }
);

$(".bestseller_product .other-products .products").on("click", function () {
  var e = $(this);
  var e_price = e.attr("price");
  var e_subscr = e.attr("subscription_price");
  var e_title = e.attr("title");
  var e_descr = e.attr("description");
  var e_meta = e.attr("subs_image");
  var e_id = e.attr("p_id");
  var e_handle = e.attr("p_handle");
  var e_short = e.attr("short_description");
  $(".beatseller_details--new_product h2.produtc_title").html(e_title);
  $(".product--price span.price-item.price-item--sale.price-item--last").html(
    e_price
  );
  $(".Subscription_peice-product span.Subscription_peice_price").html(e_subscr);
  $(".beatseller_details--new_product .description").html(e_short);
  $(".product-description-wrapper .product-description-class1").html(
    `<p>${e_descr}</p>`
  );
  $(".product-description-class2 img").attr("src", e_meta);

  var productId = $(this).data("id");
  $(".other-products .products").removeClass("active");
  $(this).addClass("active");
  $(".selling_plan_custom").removeClass("active");
  $(".variants_div .variants").removeClass("active");
  $(".selling_plan_custom").each(function () {
    var sellingPlanId = $(this).data("id");
    if (productId === sellingPlanId) {
      // $(this).addClass('active');
      $(this).find(".combo-menu .selling_variants").removeClass("active");
      $(this)
        .addClass("active")
        .find(".selling_variants:first")
        .addClass("active");
    }
  });
  $(".variants_div .variants").each(function () {
    var variants = $(this).data("id");
    if (productId === variants) {
      $(this).find(".variant_ids").removeClass("active");
      $(this).addClass("active").find(".variant_ids:first").addClass("active");
    }
  });
  $($(this).find(".variant_ids")).each(function (index) {
    var e_var = $(this).attr("data-id");
    $(
      '.variants_div .variants.active .variant_ids[data-index="' + index + '"]'
    ).attr("data-id", e_var);
  });
  $.ajax({
    type: "GET",
    async: false,
    url: "/products/" + e_handle + ".json",
    dataType: "json",
    success: function (response) {
      // console.log(response);
      var product_data = response.product;
      var thumbnailsHtml = "";
      for (var i = 0; i < product_data.images.length; i++) {
        var src = product_data.images[i].src;
        thumbnailsHtml += `<img class="thumb_img" src="${src}">`;
      }
      $(".thumbnail").html(thumbnailsHtml);
    },
    error: function (xhr, status, error) {
      console.log("Error fetching product data:", error);
    },
  });
  $(".selling_plan_slider .selling_plan_custom.active .add_cart button").attr(
    "data-id",
    e_id
  );
  $(
    ".selling_plan_slider .selling_plan_custom.active .buttons_radio .subscribe_btn"
  ).attr("data-id", e_id);
  if ($(".subscription.buy_sub").hasClass("active")) {
    $(".selling_plan_slider .selling_plan_custom.active .buttons_radio").show();
  } else {
    $(".selling_plan_slider .selling_plan_custom.active .buttons_radio").hide();
  }
});

if (window.matchMedia("(max-width: 992px)").matches) {
  $(".stories .slider_mobile").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    dots: true,
  });
}
$(".testimonial .slider_mobile").slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: false,
  arrows: true,
  dots: false,
  infinite: false,
  prevArrow:
    '<div class="prev"><svg width="12" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1.04346L1 11.0435L11 21.0435" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
  nextArrow:
    '<div class="next"><svg width="12" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 21.0435L11 11.0435L1 1.04346" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});
$(".bestseller_product .products_show ").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  arrows: true,
  dots: false,
  prevArrow:
    '<div class="prev"><svg width="12" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1.04346L1 11.0435L11 21.0435" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
  nextArrow:
    '<div class="next"><svg width="12" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 21.0435L11 11.0435L1 1.04346" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
});
$(document).ready(function () {
  $('.bestseller_product .varints input[type="radio"]').change(function () {
    $(".varints").removeClass("active");
    if ($(this).is(":checked")) {
      $(this).parent().addClass("active");
    }
  });
});

$(document).ready(function () {
  $(".selling_plan_custom").on(
    "click",
    ".combo-menu .selling_variants",
    function () {
      $(this).siblings(".combo-menu .selling_variants").removeClass("active");
      $(this).addClass("active");
    }
  );

  $(".variants").on("click", ".variant_ids", function () {
    $(this).siblings(".variant_ids").removeClass("active");
    $(this).addClass("active");
    var a = $(this).attr("data-price");
    var b = $(this).attr("data-compare");
    $(this)
      .closest(".beatseller_details")
      .find(
        ".price__container span.price-item.price-item--sale.price-item--last"
      )
      .text(a);
    $(this)
      .closest(".beatseller_details")
      .find(".price__container .price-item.price-item--regular")
      .text(b);
    let title = $(this).text();
    let productTitle = $(this).attr("data-title");
    var textWithoutSpaces = title.replace(/\s/g, "");
    var imageFeaturedElements = document.querySelectorAll(
      ".products .featured_media .image_featured"
    );

    imageFeaturedElements.forEach(function (element) {
      var dataTitle = element.querySelector("div").getAttribute("data-title");
      if (dataTitle == productTitle) {
        let imgTags = element.querySelectorAll(".image_featured img");
        for (let i = 0; i < imgTags.length; i++) {
          let imageSrc = imgTags[i].getAttribute("src");
          if (imageSrc && imageSrc.includes(textWithoutSpaces.toLowerCase())) {
            // Hide the image by setting its display style to 'none'
            imgTags[i].style.display = "block";
          } else {
            imgTags[i].style.display = "none";
          }
        }
      }
    });

    var ids = $(this).attr("data-id");
    $(".selling_plan_slider .selling_plan_custom.active .add_cart button").attr(
      "data-id",
      ids
    );
    $(
      ".selling_plan_slider .selling_plan_custom.active .buttons_radio .subscribe_btn"
    ).attr("data-id", ids);
  });
});

$(document).ready(function () {
  $(".buy_plans_subscriptions .buy_sub").each(function () {
    var isActive = $(this).hasClass("active");
    var buttonText = $(this).text().trim();
    if (isActive) {
      // If already active, show/hide elements based on buttonText
      if (buttonText === "Buy one time") {
        $(".add_cart").show();
        $(".buttons_radio").hide();
      } else if (buttonText === "Subscribe and Save") {
        $(".add_cart").hide();
        $(".buttons_radio").show();
      }
    }
  });

  $(".buy_plans_subscriptions .buy_sub").click(function () {
    $(".check_img1").addClass("remov_wildy");
    $(".check_img2").removeClass(".remov_wildy");
    $(".buy_plans_subscriptions .buy_sub").removeClass("active");
    $(this).addClass("active");
    var isActive = $(this).hasClass("active");
    var buttonText = $(this).text().trim();
    if (isActive) {
      if (!$(this).hasClass("subscription")) {
        $(".add_cart").show();
        $(".buttons_radio").hide();
      } else {
        $(".add_cart").hide();
        $(".buttons_radio").show();
      }
    }
  });
});

$(document).ready(function () {
  $('.bestseller_product .varints input[type="radio"]:checked').each(
    function () {
      $(this).parent(".varints").addClass("active");
    }
  );
  $('.bestseller_product .varints input[type="radio"]').change(function () {
    $(".varints").removeClass("active");
    if ($(this).is(":checked")) {
      $(this).parent().addClass("active");
    }
  });
});

// add to cart
$(document).on(
  "click",
  ".bestseller_product .with_selling .add_cart button",
  function (event) {
    var cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    event.preventDefault(), $(".drawer").removeClass("is-empty");
    var id = $(this)
      .parents(".beatseller_details--new_product")
      .find(".variants.active .variant_ids.active")
      .data("id");
    console.log(id);
    var category = $(this)
      .parents(".beatseller_details--new_product")
      .find(".variants.active .variant_ids.active")
      .attr("data-name");
    console.log(category);
    var quantityVal = 1;
    $.ajax({
      type: "GET",
      url: "/cart/add.js",
      data: {
        Variation: category,
        quantity: quantityVal,
        id: id,
        sections: cart.getSectionsToRender().map(function (section) {
          return section.id;
        }),
        sections_url: window.location.pathname,
      },
      dataType: "json",
      success: function (response) {
        console.log(response);
        cart.renderContents(response);
      },
      error: function () {
        console.log("error");
      },
    });
  }
);

//  without_selling
// $(document).on("click", ".bestseller_product  .without_selling .add_cart button", function (event) {
$(document).on(
  "click",
  ".bestseller_product .selling_plan_custom.active .add_cart button",
  function (event) {
    var cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    event.preventDefault(), $(".drawer").removeClass("is-empty");
    // var id = $(this).parents(".beatseller_details").find(".variants .variant_ids.active").data("id");
    var id = $(this).data("id");
    var category = $(this)
      .parents(".beatseller_details--new_product")
      .find(".variants .variant_ids.active")
      .attr("data-name");
    console.log(category);
    var quantityVal = 1;
    $.ajax({
      type: "GET",
      url: "/cart/add.js",
      data: {
        Variation: category,
        quantity: quantityVal,
        id: id,
        sections: cart.getSectionsToRender().map(function (section) {
          return section.id;
        }),
        sections_url: window.location.pathname,
      },
      dataType: "json",
      success: function (response) {
        console.log(response);
        cart.renderContents(response);
      },
      error: function () {
        console.log("error");
      },
    });
  }
);

// subscription

// $(document).on("click", ".bestseller_product .subscribe_btn", function(event) {
$(document).on(
  "click",
  ".bestseller_product .selling_plan_custom .subscribe_btn",
  function (event) {
    var cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    event.preventDefault();
    $(".drawer").removeClass("is-empty");
    // var id = $(this).parents(".beatseller_details").find(".variants.active .variant_ids.active").data("id");
    var id = $(this).data("id");
    var selling_plan_id = $(this)
      .parents(".beatseller_details")
      .find(".selling_variants.active option.combo-option.selected")
      .attr("value");
    console.log(selling_plan_id, "gkfkfkkf");
    var category = $(this)
      .parents(".beatseller_details")
      .find(".variants.active .variant_ids.active")
      .attr("data-name");
    console.log(category);
    var quantityVal = 1;
    $.ajax({
      type: "GET",
      url: "/cart/add.js",
      data: {
        Variation: category,
        quantity: quantityVal,
        selling_plan: selling_plan_id,
        id: id,
        sections: cart.getSectionsToRender().map(function (section) {
          return section.id;
        }),
        sections_url: window.location.pathname,
      },
      dataType: "json",
      success: function (response) {
        console.log(response);
        cart.renderContents(response);
      },
      error: function () {
        console.log("error");
      },
    });
  }
);

var products = document.querySelectorAll(
  ".bestseller_product  .other-products .products"
);
products.forEach(function (product) {
  product.addEventListener("click", function () {
    $(".featured_media").find("img").hide();
    var imgTag = product.querySelector("img").getAttribute("alt");
    var imageFeaturedElements = document.querySelectorAll(
      ".products .featured_media .image_featured"
    );
    // console.log(imageFeaturedElements)
    imageFeaturedElements.forEach(function (element) {
      var dataTitle = element.querySelector("div").getAttribute("data-title");
      // console.log(dataTitle);
      var imageTitlt = element.querySelector("img");
      imageTitlt.style.display = "none";
      if (dataTitle == imgTag) {
        imageTitlt.style.display = "block";
      } else {
        imageTitlt.style.display = "none";
      }
    });
  });
});

$(document).ready(function () {
  $(".products .active").click();
  $(document).on("change", ".selling_variants", function () {
    $(this).find("option").removeClass("selected");
    $(this).find("option:selected").addClass("selected");
    var selectedValue = $(this).find("option.selected").val();
  });
});
// 
$('.variant_ids').on('click', function(){
    var price = $(this).attr('data-price');
    var compare = $(this).attr('data-compare');
    $(this).parents('.beatseller_details').find('.price_home .main_price').html(price);
    $(this).parents('.beatseller_details').find('.price_home .compare').html(compare);
});


$('.other-products .products').on('click', function(){
    var price = $(this).attr('price');
    var compare = $(this).attr('comapre');
    $(this).parents('.beatseller_details').find('.price_home .main_price').html(price);
    $(this).parents('.beatseller_details').find('.price_home .compare').html(compare);
});






















